import React from "react";
import { useTranslation } from "react-i18next";
import Layout from "../../components/Layout";

const Forbidden = () => {
  const { t } = useTranslation("common");

  return (
    <Layout title={t("forbidden")}>
      <div className="p-6 bg-white dark:bg-gray-800 rounded-lg border border-gray-100 dark:border-gray-700">
        <h2 className="text-lg font-semibold">{t("forbidden")}</h2>
      </div>
    </Layout>
  );
};

export default Forbidden;
